import { useField, useFormikContext } from 'formik';
import { UploadOptions } from 'app/domains/upload/UploadOptions';
export function DocumentOptions(props) {
    const { folder } = props;
    const { isSubmitting } = useFormikContext();
    const [, , folderHelpers] = useField('parentId');
    const [projectsField, , projectsHelpers] = useField('projects');
    const [autoTagField, , autoTagHelpers] = useField({
        name: 'autoTag',
        type: 'checkbox',
    });
    const handleSelectFolder = (newFolder) => {
        folderHelpers.setValue(newFolder.id);
    };
    const handleSelectProjects = (projects) => {
        projectsHelpers.setValue(projects);
    };
    const handleChangeAutoTag = (value) => {
        autoTagHelpers.setValue(value);
    };
    return (<UploadOptions disabled={isSubmitting} folder={folder !== null && folder !== void 0 ? folder : undefined} projects={projectsField.value} autoTag={autoTagField.value} onSelectFolder={handleSelectFolder} onChangeProjects={handleSelectProjects} onChangeAutoTag={handleChangeAutoTag}/>);
}
